import {Box} from "@mui/material";
import { HeroImage } from "../components/homepage/HeroImage";
import {InfoBox} from "../components/homepage/InfoBox";

export function Homepage() {
    return (
        <Box>
            <HeroImage/>
            <InfoBox/>
        </Box>
    )
}